import { css } from '@linaria/core';

import { type OffersSlimVariant } from '../../utils/variants';

const variantStyle = (variant: OffersSlimVariant) => {
  return variants[variant] || undefined;
};

export const ARROW_H_OFFSET_PX = 19;
const MIN_OFFER_WIDTH_SM = 300; // container < 1100px
const MIN_OFFER_WIDTH_LG = 360; // container >= 1100px
const COLUMN_GAP_PX = 12;
const RESPONSIVE_BREAKPOINT = 3 * MIN_OFFER_WIDTH_LG + 2 * COLUMN_GAP_PX; // 1104px

export const wrapper = css`
  position: relative;
`;

export const container = css`
  --column-gap: ${COLUMN_GAP_PX}px;
  display: flex;
  column-gap: var(--column-gap);
  row-gap: 0.5em;
  position: relative;

  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;

  & ~ button {
    display: none;
  }
`;

export const variants = {
  autohide: css`
    flex-wrap: wrap;

    & > div {
      width: 100%;
    }

    @container base (min-width: 768px) {
      flex-wrap: nowrap;

      & > div {
        flex: 1 0 150px;
      }
    }
  `,
  default: css`
    overflow-x: auto;
    scroll-snap-type: inline mandatory;
    --min-offer-width: ${MIN_OFFER_WIDTH_SM}px;

    @container base (min-width: ${RESPONSIVE_BREAKPOINT}px) {
      --min-offer-width: ${MIN_OFFER_WIDTH_LG}px;
    }

    & > div {
      flex: 0 0 max(min(100%, var(--min-offer-width)), calc((100% - 2 * var(--column-gap)) / 3));
      scroll-snap-align: start;
    }

    &:has(> :last-child:nth-child(1)) {
      & > div {
        flex: 0 0 100%;
      }

      & ~ button {
        display: none;
      }
    }

    &:has(> :last-child:nth-child(2)) {
      & > div {
        flex: 0 0 max(min(100%, var(--min-offer-width)), calc((100% - var(--column-gap)) / 2));
      }
    }

    & ~ button {
      background: rgba(255, 255, 255, 0.8);
      border: 0;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      --v-offset: 0px;
      --size: 33px;
      height: var(--size);
      width: var(--size);
      position: absolute;
      cursor: pointer;
      top: calc(50% - var(--size) / 2 + var(--v-offset));
      border-radius: 50%;
      box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
      transition: all 50ms;
      color: #000;
      z-index: 1;

      &:active {
        box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
        color: #555;
      }
    }

    & ~ button:first-of-type {
      left: var(--arrow-left, 0px);

      & > svg {
        transform: rotate(180deg);
      }
    }

    & ~ button:last-of-type {
      padding-top: 1px;
      right: var(--arrow-right, 0px);
    }

    &[data-uncapped] > div {
      flex: 0 0 min(100%, var(--min-offer-width));
    }

    &[data-uncapped]:has(> :last-child:nth-child(2)) > div {
      flex: 0 0 min(100%, var(--min-offer-width));
    }
  `,
};

export default (variant: OffersSlimVariant) => `${container} ${variantStyle(variant)}`;
